import * as S from './style';
import convertDate from '../../utils';
const CardResum = ({ data: { title, place, description, startDate, endDate } }) => {
  return (
    <S.Container>
      <S.ShowDate>
        <S.Details>
          {convertDate(startDate)} to {convertDate(endDate)}
        </S.Details>
        <S.Line />
      </S.ShowDate>
      <S.Card>
        <S.CardTitle>{title}</S.CardTitle>
        <S.CardPlace>{place}</S.CardPlace>
        <S.Details>{description}</S.Details>
      </S.Card>
    </S.Container>
  );
};

export default CardResum;
